/* bb booking modal — multi-attendee → POST /cart/add.js → /cart */

(function () {
  var MIN_QTY = 1;
  var MAX_QTY = 20;

  var modal = document.getElementById('bb-booking-modal');
  if (!modal) return;

  // Teleport to <body> so the modal escapes any ancestor stacking context
  // (sticky header, transformed parents, etc.) and overlays everything.
  if (modal.parentNode !== document.body) document.body.appendChild(modal);

  var form = modal.querySelector('[data-bb-booking-form]');
  var quantityInput = modal.querySelector('[data-bb-quantity-input]');
  var qtyDisplay = modal.querySelector('[data-bb-qty-display]');
  var qtyDisplayPrice = modal.querySelector('[data-bb-price-qty]');
  var qtyInc = modal.querySelector('[data-bb-qty-inc]');
  var qtyDec = modal.querySelector('[data-bb-qty-dec]');
  var attendeesEl = modal.querySelector('[data-bb-attendees]');
  var attendeesHeading = modal.querySelector('[data-bb-attendees-heading]');
  var statusEl = modal.querySelector('[data-bb-status]');
  var submitBtn = modal.querySelector('[data-bb-submit]');
  var variantSelect = modal.querySelector('[data-bb-variant-select]');
  var variantPrice = modal.querySelector('[data-bb-variant-price]');
  var addonEl = modal.querySelector('[data-bb-addon]');
  var addonCheck = modal.querySelector('[data-bb-addon-check]');

  var qty = MIN_QTY;
  var lastTrigger = null;

  function setQty(next) {
    qty = Math.max(MIN_QTY, Math.min(MAX_QTY, next));
    qtyDisplay.textContent = String(qty);
    if (qtyDisplayPrice) qtyDisplayPrice.textContent = String(qty);
    quantityInput.value = String(qty);
    qtyDec.disabled = qty <= MIN_QTY;
    qtyInc.disabled = qty >= MAX_QTY;
    if (attendeesHeading) {
      attendeesHeading.textContent = qty === 1 ? 'Teilnehmer:in' : 'Teilnehmende';
    }
    renderAttendees();
  }

  function setVariant(variantId) {
    var variantInput = form.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (!variantSelect) return;

    var selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (variantPrice && selectedOption && selectedOption.dataset.price) {
      variantPrice.textContent = selectedOption.dataset.price;
    }
  }

  function attendeeRow(index) {
    var row = document.createElement('div');
    row.className = 'bb-attendee';
    row.dataset.bbAttendee = String(index);
    row.innerHTML =
      '<h4 class="bb-attendee__title">Person ' + index + '</h4>' +
      '<div class="bb-form__row">' +
        '<div class="bb-field">' +
          '<input id="bb-attendee-' + index + '-first" class="bb-field__input" type="text" required ' +
            'placeholder="Vorname" data-bb-field="first" autocomplete="given-name">' +
          '<span class="bb-field__error">Bitte ausfüllen.</span>' +
        '</div>' +
        '<div class="bb-field">' +
          '<input id="bb-attendee-' + index + '-last" class="bb-field__input" type="text" required ' +
            'placeholder="Nachname" data-bb-field="last" autocomplete="family-name">' +
          '<span class="bb-field__error">Bitte ausfüllen.</span>' +
        '</div>' +
      '</div>' +
      '<div class="bb-field" style="margin-top:10px;">' +
        '<input id="bb-attendee-' + index + '-mail" class="bb-field__input" type="email" required ' +
          'placeholder="email@beispiel.de" data-bb-field="email" autocomplete="email">' +
        '<span class="bb-field__error">Bitte gültige E-Mail eingeben.</span>' +
      '</div>' +
      '<div class="bb-field" style="margin-top:10px; margin-bottom:18px;">' +
        '<input id="bb-attendee-' + index + '-company" class="bb-field__input" type="text" required ' +
          'placeholder="Unternehmen" data-bb-field="company" autocomplete="organization">' +
        '<span class="bb-field__error">Bitte ausfüllen.</span>' +
      '</div>';
    return row;
  }

  function buildCartPayload() {
    var data = new FormData();
    data.append('id', form.querySelector('input[name="id"]').value);
    data.append('quantity', quantityInput.value);

    var rows = attendeesEl.querySelectorAll('.bb-attendee');
    rows.forEach(function (row) {
      var n = row.dataset.bbAttendee;
      var first = row.querySelector('[data-bb-field="first"]').value.trim();
      var last = row.querySelector('[data-bb-field="last"]').value.trim();
      var mail = row.querySelector('[data-bb-field="email"]').value.trim();
      var company = row.querySelector('[data-bb-field="company"]').value.trim();

      // Human-readable summary, visible to the customer in checkout + email
      data.append('properties[Person ' + n + ']', first + ' ' + last + ' (' + mail + ')');

      // Evey Events: pre-fill its attendee form so it skips the in-app layer.
      // Keys must match the Unique IDs configured in Evey's form editor and
      // the leading underscore hides them from the customer-facing summary.
      data.append('properties[_evey:attendee:' + n + ':1:firstname]', first);
      data.append('properties[_evey:attendee:' + n + ':1:lastname]', last);
      data.append('properties[_evey:attendee:' + n + ':1:email]', mail);
      data.append('properties[_evey:attendee:' + n + ':1:unternehme]', company);
    });

    var referralEl = form.querySelector('[data-bb-referral]');
    var referral = referralEl ? referralEl.value.trim() : '';
    if (referral) {
      data.append('properties[Wie bist du auf uns aufmerksam geworden]', referral);
    }

    return data;
  }

  // Build the cart-level note_attributes payload that mirrors what the bOS
  // academy website sends. Canonical attendee + order data, independent of
  // Evey's line-item properties. attendee_N_* is emitted for every person.
  function buildCartAttributes() {
    var attrs = {};
    var rows = attendeesEl.querySelectorAll('.bb-attendee');
    rows.forEach(function (row) {
      var n = row.dataset.bbAttendee;
      attrs['attendee_' + n + '_first_name'] = row.querySelector('[data-bb-field="first"]').value.trim();
      attrs['attendee_' + n + '_last_name'] = row.querySelector('[data-bb-field="last"]').value.trim();
      attrs['attendee_' + n + '_email'] = row.querySelector('[data-bb-field="email"]').value.trim();
      attrs['attendee_' + n + '_company'] = row.querySelector('[data-bb-field="company"]').value.trim();
    });

    var prog = form.querySelector('[data-bb-program]');
    var startEl = form.querySelector('[data-bb-start]');
    var endEl = form.querySelector('[data-bb-end]');
    var referralEl = form.querySelector('[data-bb-referral]');

    if (prog && prog.value) attrs.program = prog.value;
    if (startEl && startEl.value) attrs.start_date = startEl.value;
    if (endEl && endEl.value) attrs.end_date = endEl.value;
    attrs.referral_source = referralEl ? referralEl.value.trim() : '';
    attrs.newsletter_opt_in = 'false';
    attrs.source = 'shopify-direct-store';

    return attrs;
  }

  function renderAttendees() {
    var current = attendeesEl.children.length;
    if (current < qty) {
      for (var i = current + 1; i <= qty; i++) attendeesEl.appendChild(attendeeRow(i));
    } else if (current > qty) {
      for (var j = current; j > qty; j--) attendeesEl.removeChild(attendeesEl.lastChild);
    }
    attendeesEl.classList.toggle('bb-attendees--single', qty === 1);
  }

  function open(trigger) {
    lastTrigger = trigger || null;
    setQty(MIN_QTY);
    if (addonCheck) addonCheck.checked = false;
    clearStatus();
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bb-modal-open');
    var firstInput = attendeesEl.querySelector('input');
    if (firstInput) firstInput.focus();
  }

  function close() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bb-modal-open');
    clearStatus();
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  function clearStatus() {
    statusEl.textContent = '';
    statusEl.className = 'bb-form__status';
  }

  function showError(msg) {
    statusEl.textContent = msg;
    statusEl.className = 'bb-form__status bb-form__status--error';
  }

  function validate() {
    var ok = true;
    var fields = form.querySelectorAll('input[required]');
    fields.forEach(function (input) {
      var field = input.closest('.bb-field');
      var valid = input.checkValidity() && input.value.trim() !== '';
      if (!valid) {
        field.classList.add('bb-field--error');
        ok = false;
      } else {
        field.classList.remove('bb-field--error');
      }
    });
    return ok;
  }

  function submit(e) {
    e.preventDefault();
    clearStatus();
    if (!validate()) {
      showError('Bitte fülle alle Felder korrekt aus.');
      return;
    }
    submitBtn.disabled = true;
    submitBtn.textContent = 'Wird hinzugefügt …';

    var formData = buildCartPayload();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        // Optional add-on product: same quantity as attendees. The reduced
        // price comes from an automatic Shopify discount, not from here.
        if (!addonEl || !addonCheck || !addonCheck.checked) return null;
        var addonId = addonEl.getAttribute('data-bb-addon-id');
        if (!addonId) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: addonId, quantity: quantityInput.value }),
        }).then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        });
      })
      .then(function () {
        // Order-level note_attributes, mirrors the bOS website checkout.
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: buildCartAttributes() }),
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Fehler beim Hinzufügen zum Warenkorb.';
        showError(msg);
        submitBtn.disabled = false;
        submitBtn.textContent = 'Jetzt buchen';
      });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-bb-open="booking"]');
    if (opener) {
      e.preventDefault();
      open(opener);
      return;
    }
    if (e.target.closest('[data-bb-close]')) {
      e.preventDefault();
      close();
      return;
    }
    if (e.target === modal) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
  });

  qtyInc.addEventListener('click', function () { setQty(qty + 1); });
  qtyDec.addEventListener('click', function () { setQty(qty - 1); });
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      setVariant(variantSelect.value);
    });
    setVariant(variantSelect.value);
  }
  form.addEventListener('submit', submit);

  setQty(MIN_QTY);
})();
